<template>
  <div class="claw-page">
    <ActiveScreen v-if="hasActiveGame" />
    <InactiveScreen v-if="!hasActiveGame" />
  </div>
</template>

<script>
import InactiveScreen from "@/components/InactiveScreen.vue";
import ActiveScreen from "@/components/ActiveScreen.vue";

export default {
  name: "ClawView",
  components: {
    InactiveScreen,
    ActiveScreen,
  },
  data: () => ({
    activePlay: false,
  }),
  computed: {
    hasActiveGame() {
      const activeGameDiff = this.$store.getters.getActiveGameDiff;
      // Return true if game activity is within last 14 seconds (active game)
      // Return false if no data or game is older than 14 seconds (inactive)
      return activeGameDiff !== null && activeGameDiff < 14;
    },
  },
  created() {
    this.timer = setInterval(this.getActivePlay, 2000);
  },
  methods: {
    getActivePlay() {
      this.$store.dispatch("getActiveGame");
    },
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.claw-page {
  min-height: 100vh;
  background: #f6f7f8;
  cursor: none;
}
</style>
